import { Card, CardContent, Grid, Tab, Tabs } from '@material-ui/core';
import React, { useEffect, useRef, useState } from 'react';
import {
  defaultBookFilter,
  getCodeBookParams,
  truCode,
  TruCodeEvents,
  TruCodePostEvent,
  useTrueCode,
} from '../../core/trucode';
import { TabPanel } from '../common/tabs';

type Props = TruCodeEvents & {
  api: any;
};

type Event = {
  articleId: string;

  book?: string;
  code?: string;
  codeType?: string;
};

let control = null;

/*
{code: "I11", book: "CC_ICD10", articleId: null, articleTitle: null, codeType: "ICD10CM_DX"}
articleId: null
articleTitle: null
book: "CC_ICD10"
code: "I11"
codeType: "ICD10CM_DX"
*/
let ref: any;
export function CodeBooksWrapper(props: Props) {
  const { onCodePosted, api } = props;

  const container = useRef();
  const codebookId = 'codeBooks-wrapper';
  const referenceId = 'references-wrapper';



  async function onReferenceClick(event: Event) {
    let $: any = api.$;
    console.log('onReferenceClick', event);

  !ref && 
    setTimeout(
      () => (ref = api.createControl('references', '#references-wrapper'))
    );
    onChange(null, 1);
    

      setTimeout(() => {

        if (event.articleId) {
          ref.tcTrigger('references:search', {
            articleId: event.articleId,
            term: event.code,
            bookId: event.book || '',
            option: 'None',
            mockUser: true,
          });
        } else if (event.book) {
          ref.tcTrigger('references:search', {
            term: event.code,
            bookId: event.book || '',
            option: 'None',
            mockUser: true,
          });
        }

      }, 500)
 
  
    
  }

  useEffect(() => {
    if (!control && container) {
      console.log('Creating control');
         
      const params = getCodeBookParams();

      control = api.createControl({
        type: 'codeBooks',
        bookdate: params.serviceDate,
        el:  '#' + codebookId
      });

      control.tcOn('codeBooks:codePosted', (e: TruCodePostEvent) => {
        truCode.getState().setCodes(e.codes);
        if (onCodePosted) {
          onCodePosted(e);
        }
      });
      control.tcOn('research:referenceClick', onReferenceClick);


      const term = params ? params.query : null;
      const book = params
        ? params.filter || defaultBookFilter
        : defaultBookFilter;

      // ref.tcOn('research:referenceClick', onReferenceClick);
      // ref.tcOn('references:search', onReferenceClick);

      if (term && book) {
        // console.log('Code books search', params, window['$'])
        control.tcTrigger('codeBooks:search', {
          term,
          book,
          option: 'None',
          mockUser: true,
        });
        setTimeout(() => truCode.getState().setSearch(params.query), 1700);
        //  ref.tcTrigger('references:search', { term, bookId: book, mockUser: true });
      }
    }
  }, []);

  const [value, setValue] = useState(0);
  const onChange = (_: any, i: number) => {
    setValue(i);

    if (!ref) {
      setTimeout(
        () => (ref = api.createControl('references', '#references-wrapper'))
      );
    }
  };

  useEffect(() => {
   // ref = api.createControl('references', '#references-wrapper')
  }, []);

  const tabStyle: any = { width: '100vw', height: '93vh', overflowY: 'hidden' };
  const wrapperStyle: any = {
    width: '100vw',
    height: '93vh',
    overflowY: 'hidden',
  };

  return (
    <div style={{ width: '100vw', height: '100vh', overflowY: 'hidden' }}>
      <Tabs value={value} onChange={onChange}>
        <Tab label="Code Books" color="primary" />
        <Tab label="Reference" color="primary" />
      </Tabs>
      <div className="trucode" style={tabStyle}>
        <TabPanel value={value} index={0}>
          <div ref={container} id={codebookId} style={wrapperStyle} />
        </TabPanel>

        <TabPanel value={value} index={1}>
          <div
            id="tc-references"
            className="trucode"
            style={{ width: '100vw', height: '100%', overflowY: 'hidden' }}
          >
            <div id={referenceId} style={wrapperStyle} />
          </div>
        </TabPanel>
      </div>
    </div>
  );
}

export function CodeBooks(props: TruCodeEvents) {
  const api = useRef();
  const [ready, setReady] = useState(api && api.current !== undefined);

  useTrueCode({
    trueCodeReady: (trueCodeApi: any) => {
      api.current = trueCodeApi;
      setReady(true);
    },
  });
  return (
    <>
      {ready && api.current !== undefined ? (
        <CodeBooksWrapper {...props} api={api.current} />
      ) : (
        <p>Loading True Code ... </p>
      )}
    </>
  );
}

function Resource(props: { content: string }) {
  const ref: any = React.createRef();
  useEffect(() => {
    const el: any = ref?.current;
    if (el) {
      el.scrollTop = 0;
    }
  });

  return (
    <Grid
      container
      style={{ width: '100%', height: '83vh' }}
      justify="center"
      alignItems="center"
    >
      {' '}
      {!!props.content.length ? (
        <Grid item style={{ paddingTop: 12 }}>
          <Card>
            <CardContent>
              <div
                ref={ref}
                style={{
                  padding: '12px',
                  width: '70vw',
                  height: '83vh',
                  overflowY: 'auto',
                }}
              >
                <div dangerouslySetInnerHTML={{ __html: props?.content }} />
              </div>
            </CardContent>
          </Card>
        </Grid>
      ) : (
        <Grid item>No Resource Selected</Grid>
      )}
    </Grid>
  );
}
